import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { FaEyeDropper } from 'react-icons/fa';

const ColorPicker = ({ selectedColorCode, setSelectedColorCode }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [inputValue, setInputValue] = useState(selectedColorCode || '#000000');

  const handleChange = (newColor) => {
    setSelectedColorCode(newColor);
    setInputValue(newColor);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Validate hex format before applying
    const isValidHex = /^#([0-9A-F]{3}){1,2}$/i.test(value);
    if (isValidHex) {
      setSelectedColorCode(value);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        onClick={() => setShowPicker(!showPicker)}
        className="d-flex align-items-center px-3 py-2"
        style={{
          backgroundColor: selectedColorCode,
          borderRadius: '10px',
          cursor: 'pointer',
          boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
          width: 'fit-content',
        }}
      >
        <FaEyeDropper color="white" size={18} className="me-2" />
        <input
          value={inputValue}
          onChange={handleInputChange}
          style={{
            color: '#2c3e50',
            fontWeight: '500',
            backgroundColor: '#fff',
            height: '30px',
            width: '80px',
            borderRadius: '3px',
            border: 'none',
            padding: '0 8px',
            outline: 'none',
          }}
        />
      </div>

      {showPicker && (
        <div style={{ position: 'absolute', top: '45px', zIndex: 1000 }}>
          <HexColorPicker color={selectedColorCode} onChange={handleChange} />
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
